import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=1ffc7148&scoped=true"
import script from "./ChartWidget.vue?vue&type=script&lang=js"
export * from "./ChartWidget.vue?vue&type=script&lang=js"
import style0 from "./ChartWidget.vue?vue&type=style&index=0&id=1ffc7148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc7148",
  null
  
)

export default component.exports